import { userSlice } from '../../../slices/userSlice'
import { FC } from 'react'
import { UserList } from '../UserList'
import { ChevronLeft } from 'lucide-react'
import { cn, Button } from '@wellesley/ui'

type SwitchUserProfileHeaderProps = {
  title: string
  onBack: () => void
}

export const SwitchUserProfileHeader: FC<SwitchUserProfileHeaderProps> = ({
  title,
  onBack,
}) => (
  <div className="p-s relative flex items-center justify-center border-b">
    <Button
      variant="tertiary"
      size="icon_s"
      onClick={onBack}
      className="left-s absolute text-gray-900"
      aria-label="Back"
    >
      <ChevronLeft size={20} />
    </Button>
    <h2 className="text-base font-medium text-gray-900">{title}</h2>
  </div>
)

type SwitchUserProfileContentProps = {
  users: ReturnType<typeof userSlice.selectors.selectUsers>
  selectedUserId: string | null | undefined
  className?: string
  onUserSelect: (id: string) => void
}

export const SwitchUserProfileContent: FC<SwitchUserProfileContentProps> = ({
  users,
  className,
  selectedUserId,
  onUserSelect,
}) => (
  <div className={cn('gap-xxxs pb-xxs px-xxs flex flex-col', className)}>
    <div className="flex-1 overflow-auto">
      <UserList
        users={users}
        selectedUserId={selectedUserId}
        onUserSelect={onUserSelect}
      />
    </div>
  </div>
)

type SwitchUserProfileProps = {
  users: ReturnType<typeof userSlice.selectors.selectUsers>
  selectedUserId: string | null | undefined
  onUserSelect: (id: string) => void
  onBack: () => void
}

export const SwitchUserProfile: FC<SwitchUserProfileProps> = ({
  users,
  selectedUserId,
  onUserSelect,
  onBack,
}) => {
  return (
    <div className="gap-xxxs flex h-full flex-col">
      <SwitchUserProfileHeader title="Switch user profile" onBack={onBack} />
      <SwitchUserProfileContent
        users={users}
        selectedUserId={selectedUserId}
        onUserSelect={onUserSelect}
      />
    </div>
  )
}
